/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient {
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
     */
    type?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
     */
    details_push_date?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
     */
    details_extraction_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
     */
    is_extracting_details?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH'
} as const;
export type FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum = typeof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum[keyof typeof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'details_push_date': !exists(json, 'details_push_date') ? undefined : json['details_push_date'],
        'details_extraction_date': !exists(json, 'details_extraction_date') ? undefined : json['details_extraction_date'],
        'is_extracting_details': !exists(json, 'is_extracting_details') ? undefined : json['is_extracting_details'],
        'is_screener_document_upload_in_progress': !exists(json, 'is_screener_document_upload_in_progress') ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': !exists(json, 'is_additional_document_upload_in_progress') ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': !exists(json, 'is_generated_document_upload_in_progress') ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSON(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'type': value.type,
        'details_push_date': value.details_push_date,
        'details_extraction_date': value.details_extraction_date,
        'is_extracting_details': value.is_extracting_details,
        'is_screener_document_upload_in_progress': value.is_screener_document_upload_in_progress,
        'is_additional_document_upload_in_progress': value.is_additional_document_upload_in_progress,
        'is_generated_document_upload_in_progress': value.is_generated_document_upload_in_progress,
    };
}

